import type { IconData } from '@stacksjs/iconify-core'

export const xx4x3: IconData = {
  "body": "<path fill=\"#fff\" fill-rule=\"evenodd\" stroke=\"#adb5bd\" stroke-width=\"1.1\" d=\"M.5.5h638.9v478.9H.5z\"/><path fill=\"none\" stroke=\"#adb5bd\" stroke-width=\"1.1\" d=\"m.5.5l639 479m0-479l-639 479\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default xx4x3
